import { render, staticRenderFns } from "./SuccessIcon.vue?vue&type=template&id=228ad96f&scoped=true&"
import script from "./SuccessIcon.vue?vue&type=script&lang=ts&"
export * from "./SuccessIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessIcon.vue?vue&type=style&index=0&id=228ad96f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ad96f",
  null
  
)

export default component.exports